import {
  DataRequiredForProperInspection,
  PartCommentHistoryPage,
  Route,
  ServiceAction,
  populateRoute,
} from "@repo/common"
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query"
import { request } from "../api"

async function fetchProperInspectionData(jobId: string) {
  return await request<DataRequiredForProperInspection>({
    url: populateRoute(
      Route.PROPER_INSPECTION_CONTROLLER__FIND_PROPER_INSPECTION_DATA_FOR_JOB,
      jobId,
    ),
    method: "GET",
  })
}

async function fetchPartCommentHistory(
  storeId: string,
  partId: string,
  action: ServiceAction | null,
  page: number,
  size: number,
) {
  return await request<PartCommentHistoryPage>({
    url: populateRoute(
      Route.PROPER_INSPECTION_CONTROLLER__FIND_PART_COMMENT_HISTORY,
      storeId,
      partId,
    ),
    params: action ? { page, size, action } : { page, size },
    method: "GET",
  })
}

const properInspectionQueries = {
  detail: (jobId: string) =>
    queryOptions({
      queryKey: ["proper-inspection", jobId],
      queryFn: () => fetchProperInspectionData(jobId),
    }),
  partCommentHistory: (
    storeId: string,
    partId: string,
    action: ServiceAction | null,
  ) =>
    infiniteQueryOptions({
      queryKey: [
        "proper-inspection",
        "part-comment-history",
        storeId,
        partId,
        action,
      ],
      queryFn: ({ pageParam }) =>
        fetchPartCommentHistory(storeId, partId, action, pageParam, 10),
      initialPageParam: 1,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.hasMore ? allPages.length + 1 : undefined,
    }),
}

export default properInspectionQueries
